module.exports = __webpack_public_path__ + "img/744.19eb11fc.jpg";